export default [
  {
    path: '/integrations/billers/built_in/suppliers/:id',
    name: 'SupplierRetrieveUpdate',
    component: () => import(/* webpackChunkName: "supporting-documents" */ '@/views/integrations/billers/built_in/SupplierRetrieveUpdate.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'Integrations',
      requireAuth: true,
      requireAccount: true,
      title: 'Proveedor'
    }
  },
  {
    path: '/integrations/billers/built_in/suppliers',
    name: 'SupplierListCreate',
    component: () => import(/* webpackChunkName: "supporting-documents" */ '@/views/integrations/billers/built_in/SupplierListCreate.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'Integrations',
      requireAuth: true,
      requireAccount: true,
      title: 'Proveedores'
    }
  }
]